import { Extension as o } from "../../node_modules/@tiptap/core/dist/index.mjs";
import { unsetTextStyleAttribute as l } from "../text-style-extension/utils/unset-text-style-attribute.mjs";
const u = o.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (t) => {
              var r;
              return (r = t.style.color) == null ? void 0 : r.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.color ? {
              style: `color: ${t.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (t) => ({ chain: r }) => r().setMark("textStyle", { color: t }).run(),
      unsetColor: () => ({ tr: t, state: r, dispatch: e }) => l("color", r, t, e)
    };
  }
});
export {
  u as TextColor
};
